import { createSlice } from '@reduxjs/toolkit';
import { FolderState } from '../../params/redux/folder';
import { createFolderThunk, deleteFolderThunk, fetchFoldersThunk } from '../thunks/folder';

// Initial state with default values for authentication and user info
const initialState: FolderState = {
    folders: [],
    selectedFolder: null,
    selectedFolderForEdit: null,
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const folderSlice = createSlice({
    // Slice name
    name: 'folder',
    // inital state for the slice
    initialState,
    reducers: {
        settingSelectedFolder: (state, action) => {
            state.selectedFolder = action.payload;
        },
        settingSelectedFolderForEdit: (state, action) => {
            state.selectedFolderForEdit = action.payload;
        },
        // Resets loading states related to app actions
        resettingFolderLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingFolderData: () => initialState
    },
    extraReducers: (builder) => {
        // Handle async actions for login
        builder
            .addCase(fetchFoldersThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchFoldersThunk.fulfilled, (state, action) => {
                state.folders = action.payload as [];
            })
            .addCase(fetchFoldersThunk.rejected, (state) => {
                state.folders = [];
            });
        builder
            .addCase(createFolderThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isCreating = true;
            })
            .addCase(createFolderThunk.fulfilled, () => {
                //
            })
            .addCase(createFolderThunk.rejected, () => {
                //
            });
        builder
            .addCase(deleteFolderThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isDeleting = true;
            })
            .addCase(deleteFolderThunk.fulfilled, () => {
                //
            })
            .addCase(deleteFolderThunk.rejected, () => {
                //
            });
    }
});

// Exporting actions for updating app state
export const {
    settingSelectedFolderForEdit,
    settingSelectedFolder,
    resettingFolderData,
    resettingFolderLoader
} = folderSlice.actions;

// Exporting the reducer to be used in the store
export default folderSlice.reducer;
